<!--Pulsanti di navigazione-->
<app-program-buttons></app-program-buttons>
<app-workshop-buttons24></app-workshop-buttons24>
<app-proceedings-button24></app-proceedings-button24>
<hr>
<!--Tabelle orari-->
<app-orari-institutional-session24></app-orari-institutional-session24>
<app-orari-scientific-session24></app-orari-scientific-session24>
<app-orari-workshops24></app-orari-workshops24>